// Small pure helpers shared by Calendar.js, Dashboard.js, Pods.js, Contacts.js and Notes.js.

// Emails are case-insensitive everywhere in the app (only passwords aren't): store and compare them lowercased.
export const normEmail = (s) => (s || "").trim().toLowerCase();

// "HH:MM" (24h) → localized time, e.g. "7:00 PM".
export function formatTime(timeStr) {
  if (!timeStr) return "";
  const [h, m] = timeStr.split(":").map(Number);
  const d = new Date();
  d.setHours(h, m, 0, 0);
  return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

// Local "YYYY-MM-DD" key. Never use toISOString() for date keys (UTC shifts the day in the evening).
export function localDateKey(d) {
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
}

// "Crimp Fried Rice" → "CF"; single word → first two letters.
export function getInitials(value) {
  if (!value) return "";
  const parts = value.trim().split(/\s+/);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return value.slice(0, 2).toUpperCase();
}

export const getEventKind = (ev) => ev.eventKind || "event";

// Whole days from one "YYYY-MM-DD" key to another (b − a).
export const dayDiff = (a, b) => Math.round((new Date(b + "T00:00") - new Date(a + "T00:00")) / 86400000);
export const shortDay = (key) => new Date(key + "T00:00").toLocaleDateString(undefined, { weekday: "short" });

// "Today", "Tomorrow", "Mon" within a week, else "Oct 24".
export function relDay(key, todayKey = localDateKey(new Date())) {
  const d = dayDiff(todayKey, key);
  if (d === 0) return "Today";
  if (d === 1) return "Tomorrow";
  if (d > 1 && d < 7) return shortDay(key);
  return new Date(key + "T00:00").toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

// Unix ms → "Just now", "12m ago", "3h ago", "Yesterday", "Tue", "Oct 2".
export function timeAgo(ms) {
  const mins = Math.round((Date.now() - ms) / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  if (days === 1) return "Yesterday";
  if (days < 7) return new Date(ms).toLocaleDateString(undefined, { weekday: "short" });
  return new Date(ms).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
